import React from 'react';
import InicioSlider from './InicioSlider';
import LatestProducts from './LatestProducts';
import OfferGrid from './OfferGrid';
import ServicesSection from './ServicesSection';
import AIProductsSection from './AIProductsSection';
import AIChatSection from './AIChatSection';
import SEO from '../shared/SEO';
const Inicio = () => {
  return (
    <>
      <SEO
        title="Tienda de Remeras y Ropa Original"
        description="REM Enterprises - Tu tienda online de remeras originales, personalizadas y productos únicos en Uruguay. Envíos a todo el país. ¡Encontrá tu estilo!"
        url="/"
        type="website"
      />
      <div id="inicio">
        <header>
          <InicioSlider />
        </header>
        <main>
          <OfferGrid />
          <LatestProducts />
          <ServicesSection />
          <AIProductsSection />
          <AIChatSection />
        </main>
      </div>
    </>
  );
};

export default Inicio;
